module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/crocodile.ddc9af65.png";